import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../context/Provider";
import {
  Box,
  Tabs,
  Tab,
  TextField,
  Typography,
  Stack,
  Grid,
  Link
} from "@mui/material";
import { StyledItem, StyledAction, StyledSpacer } from "../../Provider.styles";
import Profile from "../../../PatientBoard/microViews/Profile/Profile";
import Details from "../../../PatientBoard/microViews/Details/Details";
import Button from "components/shared/Button/Button";
import Session from "helpers/session";
import API from "api";
import { RowInterface } from "context/initialState/Provider";
import theme from "helpers/mui-theme.helper";
import { useNavigate } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface AssignmentProps {
  header: string;
  list: RowInterface[];
  type: "add" | "subtract";
  action: (event: any, type: string) => void;
}

interface EditProps {
  type: "coordinator" | "member";
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`
  };
}

const AssignmentList = (props: AssignmentProps) => {
  return (
    <div>
      <span>{props.header}</span>
      {props.list.map((patient) => {
        return (
          <StyledItem key={patient.id}>
            {patient.name}
            <StyledAction
              id={patient.id}
              onClick={(event: any) => {
                props.action(event, props.type);
              }}
            >
              {props.type === "add" ? "+" : "-"}
            </StyledAction>
          </StyledItem>
        );
      })}
    </div>
  );
};

export default function Edit(props: EditProps) {
  const { member, provider, memberDispatch } = useContext(GlobalContext);
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const [assignedList, setAssignedList] = useState<RowInterface[]>([]);
  const [availableList, setAvailableList] = useState<RowInterface[]>([]);
  const [showingAvailable, setShowingAvailable] = useState<RowInterface[]>([]);
  const [originalList, setOriginalList] = useState<string[]>([]);
  const [isDisabled, setDisabled] = useState<boolean>(true);
  let coordDictionary = {};

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleShowingChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newShowing = availableList.filter((A) => {
      return A.name.toLowerCase().includes(event.target.value.toLowerCase());
    });
    setShowingAvailable(newShowing);
  };

  const handleAddAll = () => {
    setAssignedList(availableList.concat(assignedList));
    setDisabled(false);
    setShowingAvailable([]);
  };
  const handleRemoveAll = () => {
    setAssignedList([]);
    setDisabled(false);
    setShowingAvailable(assignedList.concat(availableList));
  };
  const handleCoordinatorToggle = (event: any, type: string) => {
    if (props.type === "coordinator") {
      provider?.memberList.map((memb: RowInterface) => {
        // @ts-ignore
        coordDictionary[memb.id] = memb;
      });
    } else {
      provider?.coordinatorList.map((coord: RowInterface) => {
        // @ts-ignore
        coordDictionary[coord.id] = coord;
      });
    }
    // move from one column to another
    setDisabled(false);
    const targetCoordinator = event.target.id;
    if (type === "add") {
      setAvailableList(
        availableList.filter((coord) => {
          return coord.id !== targetCoordinator;
        })
      );
      setShowingAvailable(
        showingAvailable.filter((coord) => {
          return coord.id !== targetCoordinator;
        })
      );

      setAssignedList(
        // @ts-ignore
        assignedList.concat([coordDictionary[targetCoordinator]])
      );
    } else {
      setAssignedList(
        assignedList.filter((coord) => {
          return coord.id !== targetCoordinator;
        })
      );

      setAvailableList(
        // @ts-ignore
        availableList.concat([coordDictionary[targetCoordinator]])
      );

      setShowingAvailable(
        // @ts-ignore
        showingAvailable.concat([coordDictionary[targetCoordinator]])
      );
    }
  };

  const applyChanges = () => {
    if (props.type === "coordinator") {
      let newList = assignedList.map((A) => {
        return A.id;
      });
      let assignmentsAdded: string[] = newList.filter((id) => {
        return !originalList.includes(id);
      });
      let assignmentsRemoved: string[] = originalList.filter((O) => {
        return !newList.includes(O);
      });
      console.log("assignmentsAdded", assignmentsAdded);
      console.log("assignmentsRemoved", assignmentsRemoved);
      // // Make call for additions
      API.kore.members.addSingleAssociations(
        assignmentsAdded,
        member?.current.id || "",
        Session.crackCookieToken("provider")
      );
      // // Make call for deletions
      API.kore.members.removeSingleAssociations(
        assignmentsRemoved,
        member?.current.id || "",
        Session.crackCookieToken("provider")
      );
      setDisabled(true);
      navigate(`/provider/members`);
    } else {
      const sendList = assignedList.map((item) => {
        return item.id;
      });
      console.log("New Coordinators: ", sendList);
      API.kore.members
        .updateAssociations(
          member?.current.id || "",
          sendList,
          Session.crackCookieToken("provider")
        )
        .then((update) => {
          memberDispatch({ type: "CHANGE_TARGET_MEMBER", payload: update });
          setDisabled(true);
        });
      navigate(`/provider/members`);
    }
  };

  useEffect(() => {
    const associationsCall =
      props.type === "coordinator"
        ? API.kore.coordinator.getAssociations(
            member?.current.id || "",
            Session.crackCookieToken("provider")
          )
        : API.kore.members.getAssociations(
            member?.current.id || "",
            Session.crackCookieToken("provider")
          );
    associationsCall.then((update) => {
      let eliminate = {};
      let available: string[] = [];
      let assigned: string[] = update;
      setOriginalList(update);
      // TODO: Have way to grab all members for Coord assignments
      if (props.type === "coordinator") {
        provider?.memberList.map((memb: RowInterface) => {
          // @ts-ignore
          coordDictionary[memb.id] = memb;
          available.push(memb.id);
        });
      } else {
        provider?.coordinatorList.map((coord: RowInterface) => {
          // @ts-ignore
          coordDictionary[coord.id] = coord;
          available.push(coord.id);
        });
      }
      let fullAssigned = assigned.map((coord) => {
        // @ts-ignore
        eliminate[coord] = true;
        // @ts-ignore
        return coordDictionary[coord];
      });
      const fullAvailable = available.map((coord) => {
        // @ts-ignore
        if (!eliminate[coord]) {
          // @ts-ignore
          return coordDictionary[coord];
        }
      });
      // console.log(assigned)
      // console.log(coordDictionary)
      // console.log(available)
      if (!fullAssigned[0]) {
        fullAssigned = [];
      }
      setAssignedList(fullAssigned);
      setAvailableList(
        fullAvailable.filter((C) => {
          return C !== undefined;
        })
      );
      setShowingAvailable(
        fullAvailable.filter((C) => {
          return C !== undefined;
        })
      );
    });
  }, [props.type]);

  return (
    <Box
      sx={{
        overflow: "scroll",
        position: "fixed",
        top: 160,
        bottom: 68,
        left: 120,
        right: 125,
        bgcolor: "background.paper"
      }}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{
          borderRight: 1,
          borderColor: "divider",
          alignItems: "flex-start"
        }}
      >
        <Tab label="Profile" {...a11yProps(0)} />
        {props.type === "member" && <Tab label="Details" {...a11yProps(1)} />}
        {props.type === "member" && (
          <Tab
            label={`Manage ${
              /*${props.type === 'coordinator'? 'Members' :*/ ""
            } Coordinators`}
            {...a11yProps(/*props.type === 'coordinator' ? 1 :*/ 2)}
          />
        )}
      </Tabs>
      <TabPanel value={value} index={member?.current ? 0 : 0}>
        <Profile
          type={props.type === "member" ? "members" : "coordinator"}
          action="edit"
          isAvatar={false}
        />
      </TabPanel>
      {props.type === "member" && (
        <TabPanel value={value} index={1}>
          <Details type={props.type} action="edit" />
        </TabPanel>
      )}
      {props.type === "member" && (
        <TabPanel
          value={value}
          index={/*props.type === 'coordinator' ?  1 :*/ 2}
        >
          <Grid container>
            <Grid item xs={9} />
            <Grid item xs={3}>
              <Stack direction={"row"} spacing={6}>
                <Link onClick={handleRemoveAll}>Remove All</Link>
                <Link onClick={handleAddAll}>Add All</Link>
              </Stack>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={2} />
            <Grid item xs={4}>
              <StyledSpacer />
              <Button
                width="90%"
                variant="primary"
                onClick={applyChanges}
                disabled={isDisabled}
              >
                Apply
              </Button>
              <StyledSpacer />
              <AssignmentList
                header="Currently Assigned"
                list={assignedList}
                action={handleCoordinatorToggle}
                type="subtract"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                placeholder="search"
                size="small"
                fullWidth
                onChange={handleShowingChange}
              />
              <AssignmentList
                header={`Available ${
                  /*props.type === 'coordinator'? 'Members' :*/ "Coordinators"
                }`}
                list={showingAvailable}
                action={handleCoordinatorToggle}
                type="add"
              />
            </Grid>
          </Grid>
        </TabPanel>
      )}
    </Box>
  );
}
